import {IComponentController, IComponentOptions} from "angular";
import {BrandServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {BrandService} from "../../../brand_service/service/BrandService";
import {Brand} from "../../../brand_service/model/Brand";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

export class BrandPickerComponent implements IComponentController {

    private selectedBrandsIds: string[] = [];
    private allBrands: Brand[];

    public static instance: IComponentOptions = {
        template: require('./brand-picker.component.html'),
        controller: [BrandServiceName, ToastNotificationServiceName, BrandPickerComponent],
        bindings: {
            selectedBrandsIds: '='
        }
    };

    constructor(private brandService: BrandService,
                private toastNotificationService: ToastNotificationService) {
    }

    $onInit(): void {
        this.fetchAllowedBrandsBrands();
    }


    private fetchAllowedBrandsBrands() {
        //todo replace with seprate controller brand autocomplete query
        this.brandService.getBrands().then(
            brandsResp => {
                if (brandsResp.status == 200) {
                    this.allBrands = brandsResp.data;
                } else {
                    this.toastNotificationService.generateErrorMessage("Failed to fetch brands");
                }
            }, (err) => {
                console.error(err);
            }
        )
    }


}